import { render, staticRenderFns } from "./DetailList.vue?vue&type=template&id=5d57dc10&scoped=true"
import script from "./DetailList.vue?vue&type=script&lang=js"
export * from "./DetailList.vue?vue&type=script&lang=js"
import style0 from "./DetailList.vue?vue&type=style&index=0&id=5d57dc10&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d57dc10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d57dc10')) {
      api.createRecord('5d57dc10', component.options)
    } else {
      api.reload('5d57dc10', component.options)
    }
    module.hot.accept("./DetailList.vue?vue&type=template&id=5d57dc10&scoped=true", function () {
      api.rerender('5d57dc10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/confirmation/Components/DetailList.vue"
export default component.exports